<template>
  <div class="page-container">
    <div class="left-part">
      <div class="main-title">
        <div class="main-title-text-eng">X-Apartment Layout Tool</div>
        <div class="main-title-text-chs">公寓（旧改）设计工具</div>
      </div>
      <div class="main-img">
        <img :src="backgroundImg" alt="background img" width="70%" />
      </div>
      <div class="bottom-text">
        X-Apartment Layout Tool on ARP | XKool.ai<br />
        Designed and Developed by ART | XKool © All rights reserved
      </div>
    </div>

    <div class="right-part">
      <div class="sub-title">
        <div class="sub-title-text-eng">Start your Design Journey</div>
        <div class="sub-title-text-chs">开启全新设计旅程</div>
      </div>
      <div class="drop-card">
        <img :src="uploadLogo" alt="upload img" width="35%" />
        <div class="drop-title-text">拖拽文件到此处</div>
        <div class="drop-content-text">
          开启全新的公寓旧改设计的旅程<br />支持*.3dm文件
        </div>
        <a-button ghost @click="downloadExampleFile" icon="download"
          >Example File</a-button
        >
      </div>
      <div class="xkool-logo">
        <img :src="xkoolLogo" alt="xkool logo" width="10%" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import fileDownload from "js-file-download";

import { baseUrl } from "../utils/baseUrl";

axios.defaults.baseURL = baseUrl;
export default {
  name: "Home.vue",
  components: {},
  data() {
    return {
      // img path
      backgroundImg: require("../assets/imgs/mainPage_logo.png"),
      uploadLogo: require("../assets/imgs/upload_logo.png"),
      xkoolLogo: require("../assets/imgs/xkool-icon-logo.png"),

      // url地址
      fileUploadUrl: "/upload_file",
      downloadExampleUrl: "/download_example_file",
    };
  },
  methods: {
    // 拖拽上传文件
    onDrag(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    onDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      this.upload3dmFile(e.dataTransfer.files);
    },
    initDropFile() {
      let upload = document.querySelector(".drop-card");
      upload.addEventListener("dragenter", this.onDrag, false);
      upload.addEventListener("dragover", this.onDrag, false);
      upload.addEventListener("drop", this.onDrop, false);
    },
    // 拖拽上传3dm文件
    upload3dmFile(files) {
      this.$message.loading({
        content: `模型正在上传中...`,
        duration: 0,
        key: "upload",
      });
      let params = new FormData();
      params.append("file", files[0]);
      axios.post(this.fileUploadUrl, params).then((res) => {
        // 加载dataModel
        if (res.data === 1) {
          this.$message.success({
            content: `上传文件成功`,
            duration: 1,
            key: "upload",
          });
          this.$store.dispatch("getFileName", files[0].name);
          this.$router.push({ path: "/ApartmentLayout" });
        } else {
          this.$message.error({
            content: `上传文件失败`,
            key: "upload",
          });
        }
      });
    },
    /** 下载示例文件 */
    downloadExampleFile() {
      axios
        .post(this.downloadExampleUrl, {}, { responseType: "blob" })
        .then((response) => {
          fileDownload(response.data, "example_file.3dm");
        });
    },
  },
  mounted() {
    this.initDropFile();
  },
};
</script>

<style scoped>
.page-container {
  width: calc(100vw);
  height: calc(100vh);
  display: flex;
}
.left-part {
  width: calc(61vw);
  height: calc(100vh);
  background-color: #5f50f6;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 30px;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 16px;
}
.main-title {
  width: 100%;
}
.main-title-text-eng {
  color: white;
  font-size: 280%;
  font-weight: 500;
}
.main-title-text-chs {
  color: white;
  font-size: 180%;
  font-weight: 600;
}
.main-img {
  display: flex;
  justify-content: center;
}
.bottom-text {
  width: 100%;
  text-align: center;
  font-size: 90%;
  color: white;
  font-weight: lighter;
}
.right-part {
  width: calc(39vw);
  height: calc(100vh);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 100px;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 40px;
}
.sub-title {
  width: 100%;
  flex-direction: column;
}
.sub-title-text-eng {
  color: #5f50f6;
  font-size: 160%;
  font-weight: 500;
  text-align: center;
}
.sub-title-text-chs {
  color: #5f50f6;
  text-align: center;
  font-size: 130%;
  font-weight: 500;
}
.drop-card {
  width: 380px;
  height: 420px;
  border-radius: 20px;
  background-color: #5f50f6;
  box-shadow: 0px 10px 41px 6px #a4a4a4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 10%;
  padding-bottom: 10%;
}
.drop-title-text {
  color: white;
  font-size: 120%;
  font-weight: 500;
}
.drop-content-text {
  color: white;
  font-size: 90%;
  font-weight: lighter;
  text-align: center;
}
.xkool-logo {
  width: 100%;
  text-align: center;
}
</style>
